import React from 'react';
import { Heart, Target, Eye, Award } from 'lucide-react';

const About = () => {
  return (
    <div className="section-padding">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">About Sevasaredham</h1>
          <p className="text-xl text-gray-600">Service to Humanity</p>
        </div>

        <div className="card p-8 mb-8">
          <h2 className="text-3xl font-bold mb-4 flex items-center">
            <Heart className="mr-3 text-primary" />
            Our Story
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            Sevasaredham was founded with a simple yet powerful mission: to serve humanity and create lasting positive change in communities across India. We believe that everyone deserves access to education, healthcare, and basic necessities.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Through the dedication of our volunteers and the generosity of our donors, we have been able to impact thousands of lives, bringing hope and opportunity to those who need it most.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <div className="card p-6">
            <Target className="w-12 h-12 text-primary mb-4" />
            <h3 className="text-2xl font-bold mb-3">Our Mission</h3>
            <p className="text-gray-700">
              To empower communities through education, healthcare, and sustainable development programs, creating opportunities for a better future.
            </p>
          </div>

          <div className="card p-6">
            <Eye className="w-12 h-12 text-primary mb-4" />
            <h3 className="text-2xl font-bold mb-3">Our Vision</h3>
            <p className="text-gray-700">
              A world where every person has access to the resources and support they need to thrive and reach their full potential.
            </p>
          </div>
        </div>

        <div className="card p-8 mb-8">
          <h2 className="text-3xl font-bold mb-6 flex items-center">
            <Award className="mr-3 text-primary" />
            Our Values
          </h2>
          <ul className="space-y-4">
            {[
              { title: 'Compassion', desc: 'We lead with empathy and understanding' },
              { title: 'Integrity', desc: 'We operate with transparency and honesty' },
              { title: 'Collaboration', desc: 'We work together to achieve more' },
              { title: 'Excellence', desc: 'We strive for quality in everything we do' }
            ].map((value, i) => (
              <li key={i} className="flex items-start">
                <span className="inline-block w-2 h-2 bg-primary rounded-full mr-3 mt-2"></span>
                <div>
                  <strong className="text-gray-900">{value.title}:</strong>
                  <span className="text-gray-700"> {value.desc}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Our Team</h2>
            <p className="text-xl text-gray-600">The dedicated individuals behind Sevasaredham</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: 'Dr. Ramesh Singh',
                role: 'Founder & Chairman',
                image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=400&auto=format&fit=crop'
              },
              {
                name: 'Sunita Verma',
                role: 'Executive Director',
                image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&auto=format&fit=crop'
              },
              {
                name: 'Rajeev Malhotra',
                role: 'Head of Operations',
                image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=400&auto=format&fit=crop'
              }
            ].map((member, i) => (
              <div key={i} className="card p-0 overflow-hidden text-center group">
                <div className="h-64 overflow-hidden">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-primary font-medium">{member.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
